import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export default function BSOD({ onRecover }) {
  const [showRecovery, setShowRecovery] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowRecovery(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <motion.div
      className="bsod"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="bsod-content">
        <h1>Autonomous</h1>
        <p>A fatal exception 0E has occurred at 0028:C0011E36 in VXD VMM(01) +</p>
        <p>00010E36. The current application will be terminated.</p>
        <br />
        <p>*  Press any key to terminate the current application.</p>
        <p>*  Press CTRL+ALT+DEL again to restart your computer. You will</p>
        <p>   lose any unsaved information in all applications.</p>
        <br />
        {showRecovery ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <p className="bsod-joke">Just kidding! Our systems have 99.7% uptime 😎</p>
            <button className="bsod-button" onClick={onRecover}>
              Press any key to continue...
            </button>
          </motion.div>
        ) : (
          <p className="bsod-blink">Press any key to continue _</p>
        )}
      </div>
    </motion.div>
  );
}
